<template>
  <div class="passport">
    <div class="row">
      <div class="col-md-3 col-xs-3">
        <span class="name-label">Дата рождения</span>
        <p>{{ passport.birthday || '-' }}</p>
      </div>
      <div class="col-md-6 col-xs-6">
        <span class="name-label">Место рождения</span>
        <p>{{ passport.placebirth || '-' }}</p>
      </div>
      <div class="col-md-2 col-xs-2">
        <span class="name-label">Гражданство</span>
        <p v-if="passport.nationality && passport.nationality.iso2" class="visitor-nationality">
          <img
            :src="baseUrl + '/img/icons/' + passport.nationality.iso2 + '.svg'"
            alt="icon-flag"
            class='icon-flag'
          >{{ passport.nationality.fullName || '-' }}
        </p>
        <p v-else>-</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-xs-3">
        <span class="name-label">Вид документа</span>
        <p>{{ identification ? identification.name || '-' : '-' }}</p>
      </div>
      <div class="col-md-3 col-xs-3">
        <span class="name-label">Серия и номер</span>
        <p>{{ identification ? identification.number || '-' : '-' }}</p>
      </div>
      <div class="col-md-3 col-xs-3">
        <span class="name-label">Дата выдачи</span>
        <p>{{ identification ? identification.date_of || '-' : '-' }}</p>
      </div>
      <div class="col-md-3 col-xs-3">
        <span class="name-label">Дата окончания</span>
        <p>{{ identification ? identification.date_to || '-' : '-' }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 col-xs-9">
        <span class="name-label">Кем выдан</span>
        <p>{{ identification ? identification.place || '-' : '-' }}</p>
      </div>
      <div class="col-md-3 col-xs-3">
        <span class="name-label">Код подразделения</span>
        <p>{{ identification ? identification.code || '-' : '-' }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-xs-12">
        <span class="name-label">Адрес</span>
        <p>{{ passport.address || '-' }}</p>
      </div>
    </div>
    <visitor-documents-block :documents="documents" />
  </div>
</template>

<script>
import VisitorDocumentsBlock from './VisitorDocumentsBlock.vue'

export default {
  name: 'VisitorPassportBlock',

  components: {
    VisitorDocumentsBlock
  },

  props: {
    passport: {
      address: String,
      birthday: String,
      documents: [Object, Array],
      identification: {
        name: String,
        number: String,
        date_of: String,
        date_to: String,
        place: String,
        code: String
      },
      nationality: {
        iso2: String,
        fullName: String
      },
      placebirth: String
    }
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL
    }
  },

  computed: {
    identification() {
      return this.passport.identification
    },

    documents() {
      return this.passport.documents
    }
  }
}
</script>
